// extracted by mini-css-extract-plugin
export default {"form":"form__XCtwulnoD1lhJyaiscQo","title":"title__IB_FNLnU5B3fWMP3RV0F","subtitle":"subtitle__QpQgnWdGMf4RzyFg7tYg","cta":"cta__nTaG1ZlJDezY_pqvWeJw"};